// TODO: translateIssue
import i18next from 'i18next';
import countries from 'utils/countries.json';

export const TITLE_MENU = [
  { title: i18next.t('constants.personTitles.mr'), value: 'Mr' },
  { title: i18next.t('constants.personTitles.miss'), value: 'Miss' },
  { title: i18next.t('constants.personTitles.ms'), value: 'Ms' },
  { title: i18next.t('constants.personTitles.mrs'), value: 'Mrs' },
];

export const NATIONALITY = countries;

export const DURATION_VALIDITY = [
  { title: i18next.t('constants.timeTitles.year'), value: 'year' },
  { title: i18next.t('constants.timeTitles.month'), value: 'month' },
];

export const CABIN_CLASS = [
  { title: i18next.t('constants.cabinClasses.economy'), value: 'economy', objectValue: { RBD: 'Y' } },
  { title: i18next.t('constants.cabinClasses.business'), value: 'business', objectValue: { RBD: 'I' } },
  // { title: 'first', value: 'first', },
];

export const LOCALES = [
  {
    value: 'en',
    title: i18next.t('constants.locales.en.shortName'),
    img: '/passenger/images/locales/en.png',
  },
  {
    value: 'fa',
    title: i18next.t('constants.locales.fa.shortName'),
    img: '/passenger/images/locales/fa.png',
  },
];
